import { HubStatusFlow } from "./statusView";

const PartnerStatusView = () => {
    return (
        <main>
            <h2 className="text-center mt-10 text-lg">Fluxo para pedidos com entrega <strong>PARCEIROS</strong></h2>
            <HubStatusFlow />
        </main>
    )
}

export default PartnerStatusView;
